import React, { useCallback, useEffect, useState } from 'react';
import { Box, Flex, useDisclosure } from '@chakra-ui/react';
import { ConfirmationDialog } from '../components/organisms/ConfirmationDialog';
import { PhrasesBrowseWindow } from '../components/organisms/Maintenance/BrowseWindow/PhrasesBrowseWindow';
import PhrasesCreateWindow from '../components/organisms/Maintenance/CreateWindow/PhrasesCreateWindow';
import PhrasesEditWindow from '../components/organisms/Maintenance/EditWindow/PhrasesEditWindow';
import {
  MaintenanceHeader,
  selectTabEnum
} from '../components/organisms/Maintenance/MaintenanceHeader';
import { MaintenanceTitle } from '../components/organisms/Maintenance/MaintenanceTitle';
import PhrasesSearchBox from '../components/organisms/Maintenance/SearchWindow/PhrasesSearchBox';
import {
  PhrasesType,
  MaintenancePhrasesTable
} from '../components/organisms/Maintenance/Table/MaintenancePhrasesTable';
import { DeletePhrasesApi } from '../apis/DeleteMaintenance.api';
import { GetPhrasesApi } from '../apis/GetMaintenance.api';
import { QueryPhrasesApi } from '../apis/QueryMaintenance.api';
import { CategroyNameType } from '../apis/ApiClient';
import { chooseDataStateType } from '../components/molecules/MaintenanceModalDispLabels';
import PhrasesChangeTypeButtons from '../components/molecules/PhrasesChangeTypeButtons';
import {
  CategorySendMessageType,
  MaintenanceCompareEnum
} from '../components/constants/MaintenanceConstants';

export type PhrasesStateType = {
  type: 'phrases';
  phrases: PhrasesType;
};

export type PhrasesArrayStateType = {
  type: 'phrases';
  phrases: PhrasesType[] | undefined;
};

export interface PhrasesSearchCondition {
  sort: { key: string; sortType: boolean };
  category: string;
  phrases: string;
  count: { compare: string; countData: string };
  type: string;
  dateCreatedFrom: string;
  dateCreatedTo: string;
  dateUpdatedFrom: string;
  dateUpdatedTo: string;
}

export const PhrasesMaintenance: React.FC = () => {
  const [query, setQuery] = useState<PhrasesSearchCondition>({
    sort: { key: '', sortType: false },
    category: '',
    phrases: '',
    count: { compare: MaintenanceCompareEnum.Equal, countData: '' },
    type: '',
    dateCreatedFrom: '',
    dateCreatedTo: '',
    dateUpdatedFrom: '',
    dateUpdatedTo: ''
  });

  const [createOrUpdate, setCreateOrUpdate] = useState(false);

  const CreateOrUpdateStateSwitch = useCallback(() => {
    setQuery({
      sort: { key: '', sortType: false },
      category: '',
      phrases: '',
      count: { compare: MaintenanceCompareEnum.Equal, countData: '' },
      type: '',
      dateCreatedFrom: '',
      dateCreatedTo: '',
      dateUpdatedFrom: '',
      dateUpdatedTo: ''
    });
    setCreateOrUpdate(!createOrUpdate);
  }, [createOrUpdate]);

  const [chooseButton, setChooseButton] = useState(
    CategorySendMessageType.None
  );
  const MessageTypeChange = useCallback((type: string) => {
    setChooseButton(type);
  }, []);

  const [searchSwitch, setSearchSwitch] = useState(false);

  const SearchStateSwitch = useCallback(() => {
    setSearchSwitch(!searchSwitch);
  }, [searchSwitch]);

  const stateUpdate = (data: chooseDataStateType) => {
    if (data.type === 'phrases') {
      setChooseData(data.phrases);
    }
  };
  const DeleteApi = async () => {
    if (chooseData?.id !== undefined) {
      const response = await DeletePhrasesApi(chooseData.id);
      if (response.success) {
        setMaintenanceDatas(response.data as PhrasesType[]);
        CreateOrUpdateStateSwitch();
      }
    }
  };
  const {
    isOpen: isOpenCreate,
    onOpen: onOpenCreate,
    onClose: onCloseCreate
  } = useDisclosure();
  const {
    isOpen: isOpenBrowse,
    onOpen: onOpenBrowse,
    onClose: onCloseBrowse
  } = useDisclosure();
  const {
    isOpen: isOpenEdit,
    onOpen: onOpenEdit,
    onClose: onCloseEdit
  } = useDisclosure();
  const {
    isOpen: isOpenConfirm,
    onOpen: onToggle,
    onClose: onCloseConfirm
  } = useDisclosure();
  const [chooseData, setChooseData] = useState<PhrasesType>();
  const [maintenanceDatas, setMaintenanceDatas] = useState<
    PhrasesType[] | undefined
  >();
  const [categoryDatas, setCategoryDatas] = useState<
    CategroyNameType[] | undefined
  >();

  const GetApi = async () => {
    const responsePhrases = await GetPhrasesApi();
    if (responsePhrases.success) {
      setMaintenanceDatas(responsePhrases.data as PhrasesType[]);
    }
    const responseCategory = await QueryPhrasesApi('/categories');
    if (responseCategory.success) {
      setCategoryDatas(responseCategory.data as CategroyNameType[]);
    }
  };

  useEffect(() => {
    GetApi();
  }, []);

  return (
    <>
      <Flex direction='column' h='100vh'>
        <MaintenanceHeader selectTab={selectTabEnum.Phrases} />
        <MaintenanceTitle
          selectTab={selectTabEnum.Phrases}
          onOpen={onOpenCreate}
        />
        <Box
          position='relative'
          display='grid'
          gridTemplateRows='0.1fr 2fr 0.1fr'
          gridTemplateColumns='3fr 1fr'
          h='100%'
        >
          <PhrasesChangeTypeButtons
            Query={query}
            setQuery={setQuery}
            setMaintenanceDatas={setMaintenanceDatas}
            createOrUpdate={createOrUpdate}
            chooseButton={chooseButton}
            MessageTypeChange={MessageTypeChange}
          />
          <MaintenancePhrasesTable
            PhrasesDatas={maintenanceDatas}
            setMaintenanceDatas={setMaintenanceDatas}
            setChooseData={stateUpdate}
            onOpenBrowse={onOpenBrowse}
            onOpenEdit={onOpenEdit}
            onToggle={onToggle}
            Query={query}
            setQuery={setQuery}
            createOrUpdate={createOrUpdate}
            searchSwitch={searchSwitch}
            chooseButton={chooseButton}
          />

          <PhrasesSearchBox
            CategoryDatas={categoryDatas}
            setMaintenanceDatas={setMaintenanceDatas}
            Query={query}
            setQuery={setQuery}
            createOrUpdate={createOrUpdate}
            SearchStateSwitch={SearchStateSwitch}
          />

          {isOpenCreate && (
            <PhrasesCreateWindow
              isOpen={isOpenCreate}
              onClose={onCloseCreate}
              CategoryDatas={categoryDatas}
              setMaintenanceDatas={setMaintenanceDatas}
              CreateOrUpdateStateSwitch={CreateOrUpdateStateSwitch}
            />
          )}
          {isOpenBrowse && (
            <PhrasesBrowseWindow
              isOpen={isOpenBrowse}
              onClose={onCloseBrowse}
              BrowseData={chooseData}
            />
          )}

          {isOpenEdit && (
            <PhrasesEditWindow
              isOpen={isOpenEdit}
              onClose={onCloseEdit}
              EditData={chooseData}
              CategoryDatas={categoryDatas}
              setMaintenanceDatas={setMaintenanceDatas}
              CreateOrUpdateStateSwitch={CreateOrUpdateStateSwitch}
            />
          )}
          {isOpenConfirm && (
            <ConfirmationDialog
              isOpen={isOpenConfirm}
              onClose={onCloseConfirm}
              dispMessage={'本当に削除しますか？'}
              DeleteApi={DeleteApi}
            />
          )}
        </Box>
      </Flex>
    </>
  );
};
